/*
 * @Author: your name
 * @Date: 2020-05-25 10:25:28
 * @LastEditTime: 2020-06-04 10:40:57
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /WXStudent/src/store/actions.js
 */
import {
    getJsSdkConfig
} from '../apis/baseUrls'
import {
    WX_JS_SDK
} from './mutation-types'
import wx from 'weixin-js-sdk'
export default {
    getJsSdk() {
        getJsSdkConfig({
            apilist: ["playVoice","updateAppMessageShareData","updateTimelineShareData"],
            url: encodeURIComponent(window.location.href.split("#")[0])
        }).then(res => {
            if (res.data.code == 0) {
                wx.config({
                    debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.content.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.content.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.content.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.content.signature, // 必填，签名
                    jsApiList: res.data.content.jsApiList // 必填，需要使用的JS接口列表
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js